export const getErrorsFrag = `
    id
    folderId
    serviceId
    error
    date
    code
    data
`;
